import { useState } from 'react'
import maharajJiImg from '../../../assets/images/maharaj-ji.png'
const LINE_ANGLES = Array.from({ length: 36 }, (_, i) => i * 10)
const ELLIPSE_ANGLES = Array.from({ length: 12 }, (_, i) => i * 30)

function OrbitalWheelSvg() {
  return (
    <div
      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
      aria-hidden="true"
      style={{ width: '118%', height: '118%', zIndex: 0 }}
    >
      <svg
        viewBox="0 0 200 200"
        fill="none"
        stroke="currentColor"
        className="w-full h-full"
        style={{ color: 'rgba(245,158,11,0.18)', animation: 'custom-spin 90s linear infinite' }}
      >
        <circle cx="100" cy="100" r="98" strokeWidth="0.6" />
        <circle cx="100" cy="100" r="82" strokeWidth="0.5" strokeDasharray="1 4" />
        <circle cx="100" cy="100" r="60" strokeWidth="0.5" />
        {LINE_ANGLES.map((deg) => (
          <line key={deg} x1="100" y1="2" x2="100" y2="16" strokeWidth="0.7" transform={`rotate(${deg} 100 100)`} />
        ))}
        {ELLIPSE_ANGLES.map((deg) => (
          <ellipse key={deg} cx="100" cy="40" rx="9" ry="22" strokeWidth="0.45" transform={`rotate(${deg} 100 100)`} />
        ))}
      </svg>
    </div>
  )
}

const BADGES = [
  {
    key: 'experience',
    style: { top: '-18px', right: '-18px', animationDelay: '0s' },
    variant: 'gold',
    icon: '🏆',
    value: '15+',
    label: 'Yrs Experience',
  },
  {
    key: 'sessions',
    style: { top: '42%', left: '-22px', transform: 'translateY(-50%)', animationDelay: '-2.5s' },
    variant: 'glass',
    icon: '🔮',
    value: '10K+',
    label: 'Sessions',
  },
  {
    key: 'rating',
    style: { right: '-22px', top: '35%', transform: 'translateY(-50%)', animationDelay: '-1.2s' },
    variant: 'glass',
    hiddenOnMobile: true,
    icon: '⭐',
    value: '4.9',
    valueSuffix: '/5',
    stars: true,
  },
  {
    key: 'countries',
    style: { bottom: '12%', right: '-22px', animationDelay: '-3.8s' },
    variant: 'glass',
    hiddenOnMobile: true,
    icon: '🌍',
    value: '10+',
    label: 'Countries',
  },
]

function Badge({ badge }) {
  const isGold = badge.variant === 'gold'
  return (
    <div
      className={`absolute z-40 animate-float${badge.hiddenOnMobile ? ' hidden sm:block' : ''}`}
      style={{
        ...badge.style,
        borderRadius: '18px',
        padding: isGold ? '12px 16px' : '12px 16px',
        background: isGold
          ? 'linear-gradient(135deg,#b86e08,#F5A623,#d4870f)'
          : 'linear-gradient(135deg,rgba(18,10,4,.92),rgba(28,14,5,.88))',
        backdropFilter: isGold ? undefined : 'blur(22px)',
        border: isGold ? undefined : '1px solid rgba(245,158,11,.28)',
        boxShadow: isGold
          ? '0 10px 32px -6px rgba(245,158,11,.7),0 2px 10px rgba(0,0,0,.55),inset 0 1px 0 rgba(255,255,255,.25)'
          : '0 10px 36px -6px rgba(0,0,0,.75),inset 0 1px 0 rgba(245,158,11,.12),0 0 0 1px rgba(245,158,11,.06)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {isGold ? (
          <span style={{ fontSize: '18px', lineHeight: 1 }}>{badge.icon}</span>
        ) : (
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg,rgba(245,158,11,.28),rgba(245,158,11,.09))',
              border: '1px solid rgba(245,158,11,.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              flexShrink: 0,
            }}
          >
            {badge.icon}
          </div>
        )}
        <div>
          <p
            style={{
              fontFamily: 'var(--font-heading),serif',
              fontSize: '16px',
              fontWeight: 900,
              color: isGold ? '#0B0806' : '#FBBF24',
              letterSpacing: '.06em',
              lineHeight: 1,
              textShadow: isGold ? undefined : '0 0 18px rgba(245,158,11,.45)',
            }}
          >
            {badge.value}
            {badge.valueSuffix && (
              <span style={{ fontSize: '9px', color: 'rgba(245,158,11,.5)', marginLeft: '1px' }}>{badge.valueSuffix}</span>
            )}
          </p>
          {badge.stars ? (
            <p style={{ fontSize: '8.5px', color: '#FBBF24', letterSpacing: '.05em', marginTop: '2px' }}>★★★★★</p>
          ) : (
            <p
              style={{
                fontSize: '7px',
                textTransform: 'uppercase',
                letterSpacing: '.18em',
                color: isGold ? 'rgba(11,8,6,.65)' : 'rgba(255,255,255,.4)',
                marginTop: '2px',
              }}
            >
              {badge.label}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default function MaharajPortrait() {
  const [imgFailed, setImgFailed] = useState(false)

  return (
    <div className="relative select-none group" id="maharaj-portrait">
      <OrbitalWheelSvg />

      <div
        className="absolute pointer-events-none"
        aria-hidden="true"
        style={{
          inset: '-90px',
          background: 'radial-gradient(ellipse 70% 80% at 50% 46%,rgba(245,158,11,.18),rgba(161,60,10,.1) 50%,transparent 70%)',
          filter: 'blur(42px)',
          borderRadius: '999px',
        }}
      />
      <div
        className="absolute pointer-events-none"
        aria-hidden="true"
        style={{
          inset: '-30px',
          background: 'radial-gradient(ellipse 55% 60% at 50% 50%,rgba(245,158,11,.1),transparent 65%)',
          filter: 'blur(20px)',
          borderRadius: '999px',
        }}
      />

      <div
        className="portrait-ring-1 absolute pointer-events-none rounded-[36px]"
        aria-hidden="true"
        style={{ inset: '-22px', border: '1px solid rgba(245,158,11,.22)', boxShadow: '0 0 20px rgba(245,158,11,.06) inset' }}
      />
      <div
        className="portrait-ring-2 absolute pointer-events-none rounded-[46px]"
        aria-hidden="true"
        style={{ inset: '-42px', border: '1px dashed rgba(245,158,11,.11)' }}
      />
      <div
        className="absolute pointer-events-none rounded-[56px]"
        aria-hidden="true"
        style={{ inset: '-62px', border: '1px solid rgba(245,158,11,.05)' }}
      />

      <div
        className="relative overflow-hidden rounded-[28px]"
        style={{
          width: 'min(400px,94vw)',
          height: 'min(540px,128vw)',
          border: '1.5px solid rgba(245,158,11,.38)',
          boxShadow:
            '0 0 0 1px rgba(245,158,11,.1),0 0 0 3px rgba(245,158,11,.04),0 40px 90px -18px rgba(0,0,0,.9),0 0 80px -10px rgba(245,158,11,.22),0 0 130px -20px rgba(245,158,11,.1)',
        }}
      >
        <div style={{ position: 'absolute', top: '-1px', left: '-1px', width: '30px', height: '30px', borderTop: '2.5px solid rgba(245,158,11,.85)', borderLeft: '2.5px solid rgba(245,158,11,.85)', borderRadius: '22px 0 0 0', zIndex: 26, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: '-1px', right: '-1px', width: '30px', height: '30px', borderBottom: '2.5px solid rgba(245,158,11,.85)', borderRight: '2.5px solid rgba(245,158,11,.85)', borderRadius: '0 0 22px 0', zIndex: 26, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', top: '-1px', right: '-1px', width: '30px', height: '30px', borderTop: '2px solid rgba(245,158,11,.45)', borderRight: '2px solid rgba(245,158,11,.45)', borderRadius: '0 22px 0 0', zIndex: 26, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: '-1px', left: '-1px', width: '30px', height: '30px', borderBottom: '2px solid rgba(245,158,11,.45)', borderLeft: '2px solid rgba(245,158,11,.45)', borderRadius: '0 0 0 22px', zIndex: 26, pointerEvents: 'none' }} />

        {!imgFailed && (
          <img
            id="portrait-img"
            src={maharajJiImg}
            alt="Astrologer Raju Maharaj Ji — Vedic Jyotish Acharya"
            className="absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: 'center top' }}
            loading="eager"
            onError={() => setImgFailed(true)}
          />
        )}

        {imgFailed && (
          <div
            id="portrait-fallback"
            className="absolute inset-0 flex items-center justify-center"
            style={{ background: 'linear-gradient(145deg,#2A1408,#120804)' }}
          >
            <div className="text-center space-y-2">
              <div className="text-8xl font-royal" style={{ color: 'rgba(245,158,11,.45)', textShadow: '0 0 40px rgba(245,158,11,.25)' }}>
                ॐ
              </div>
              <p className="text-[9px] uppercase tracking-[.3em] font-royal" style={{ color: 'rgba(245,158,11,.3)' }}>
                Maharaj Ji
              </p>
            </div>
          </div>
        )}

        <div
          className="absolute inset-y-0 left-0 w-14 pointer-events-none z-10"
          style={{ background: 'linear-gradient(to right,rgba(11,8,6,.35),transparent)' }}
        />
        <div
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none z-10"
          style={{ background: 'linear-gradient(125deg,rgba(245,158,11,.09) 0%,transparent 45%,rgba(245,158,11,.05) 100%)' }}
        />
        <div
          className="absolute bottom-0 left-0 right-0 pointer-events-none z-20"
          style={{ height: '42%', background: 'linear-gradient(to top,#0B0806 0%,rgba(11,8,6,.8) 42%,transparent 100%)' }}
        />

        <div
          className="absolute bottom-0 left-0 right-0 z-30 px-6 pb-5 pt-6"
          style={{
            background: 'linear-gradient(to top,rgba(8,5,3,.97) 0%,rgba(11,8,6,.85) 55%,transparent 100%)',
            backdropFilter: 'blur(12px)',
            borderTop: '1px solid rgba(245,158,11,.15)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
            <div style={{ height: '1px', width: '14px', background: 'rgba(245,158,11,.5)' }} />
            <p className="font-royal uppercase" style={{ fontSize: '7.5px', letterSpacing: '.45em', color: 'rgba(245,158,11,.65)' }}>
              Vedic Jyotish Acharya
            </p>
            <div style={{ height: '1px', flex: 1, background: 'linear-gradient(90deg,rgba(245,158,11,.3),transparent)' }} />
          </div>
          <p className="font-royal font-bold text-white" style={{ fontSize: '16px', letterSpacing: '.06em', lineHeight: 1.15 }}>
            Raju Maharaj Ji
          </p>
          <p style={{ fontSize: '8px', letterSpacing: '.22em', color: 'rgba(255,255,255,.3)', textTransform: 'uppercase', marginTop: '3px' }}>
            Jyotish · Palmist · Vastu
          </p>
        </div>

        <div
          className="absolute top-0 left-0 right-0 h-px z-30 pointer-events-none"
          style={{ background: 'linear-gradient(90deg,transparent,rgba(245,158,11,.75),transparent)' }}
        />
        <div
          className="absolute inset-0 pointer-events-none z-10 opacity-[0.03]"
          style={{
            backgroundImage:
              "url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2280%22 height=%2280%22%3E%3Cfilter id=%22n%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.9%22 numOctaves=%224%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%2280%22 height=%2280%22 filter=%22url(%23n)%22 opacity=%221%22/%3E%3C/svg%3E')",
            backgroundSize: '80px 80px',
          }}
        />
      </div>

      {BADGES.map((badge) => (
        <Badge badge={badge} key={badge.key} />
      ))}

      <div
        className="absolute z-40 rounded-full animate-core-breathe"
        style={{ top: '8%', left: '-8%', width: '13px', height: '13px', animationDelay: '.4s', background: 'radial-gradient(circle,rgba(245,158,11,.3),rgba(245,158,11,.08))', border: '1px solid rgba(245,158,11,.55)', boxShadow: '0 0 14px rgba(245,158,11,.4),0 0 28px rgba(245,158,11,.15)' }}
      />
      <div
        className="absolute z-40 rounded-full animate-core-breathe"
        style={{ bottom: '20%', right: '-6%', width: '10px', height: '10px', animationDelay: '1.1s', background: 'radial-gradient(circle,rgba(245,158,11,.25),rgba(245,158,11,.07))', border: '1px solid rgba(245,158,11,.45)', boxShadow: '0 0 11px rgba(245,158,11,.35),0 0 22px rgba(245,158,11,.12)' }}
      />
      <div
        className="absolute z-40 rounded-full animate-core-breathe"
        style={{ top: '58%', left: '-5%', width: '7px', height: '7px', animationDelay: '2.2s', background: 'rgba(245,158,11,.18)', border: '1px solid rgba(245,158,11,.4)', boxShadow: '0 0 8px rgba(245,158,11,.3)' }}
      />
    </div>
  )
}
